import { Badge } from '@fluentui/react-components';
import { REGISTRATION_STATUS_OPTIONS } from '../constants';
import type { ERegistrationStatus } from '../types';

type TProps = {
  status: ERegistrationStatus;
};

const RegistrationStatusBadge = ({ status }: TProps) => {
  const option = REGISTRATION_STATUS_OPTIONS.find(({ value }) => value === status);

  return (
    <Badge appearance="tint" color={option?.color}>
      {option?.label ?? status}
    </Badge>
  );
};

export default RegistrationStatusBadge;
